import { IFileLoaderService } from './fileloader.types';
import { AxiosInstance } from 'axios';

export class FileLoaderService implements IFileLoaderService {
  constructor(private axios: AxiosInstance) {}

  downloadFile(path: string): Promise<Blob> {
    return this.axios
      .get<Blob>(path, { responseType: 'blob' })
      .then(({ data }) => data);
  }
}
